var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeRemaining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Timer_02",
    "data-name": "Timer 02",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M11.5,23A11.5,11.5,0,1,1,23,11.5,11.514,11.514,0,0,1,11.5,23Zm0-21.69A10.19,10.19,0,1,0,21.69,11.5,10.2,10.2,0,0,0,11.5,1.31Z",
    fill: "#f1f1f2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9869",
    "data-name": "Group 9869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M11.36,3.32V11.7H2.98A8.39,8.39,0,0,1,11.36,3.32Z",
    fill: "#f1f1f2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9870",
    "data-name": "Group 9870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M11.5,2.56a.333.333,0,0,1-.33-.33V.66a.33.33,0,1,1,.66,0V2.24A.324.324,0,0,1,11.5,2.56Z",
    fill: "#f1f1f2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9871",
    "data-name": "Group 9871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M11.5,22.67a.333.333,0,0,1-.33-.33V20.76a.33.33,0,0,1,.66,0v1.58A.333.333,0,0,1,11.5,22.67Z",
    fill: "#f1f1f2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9872",
    "data-name": "Group 9872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M22.34,12.03H20.76a.33.33,0,1,1,0-.66h1.58a.33.33,0,1,1,0,.66Z",
    fill: "#f1f1f2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9873",
    "data-name": "Group 9873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M2.23,12.03H.66a.33.33,0,1,1,0-.66H2.24a.33.33,0,1,1-.01.66Z",
    fill: "#f1f1f2"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9874",
    "data-name": "Group 9874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M18.26,5.41a.3.3,0,0,1-.23-.1.32.32,0,0,1,0-.46l1.12-1.12a.325.325,0,0,1,.46.46L18.5,5.31A.369.369,0,0,1,18.26,5.41Z",
    fill: "#f1f1f2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9875",
    "data-name": "Group 9875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M4.05,19.63a.3.3,0,0,1-.23-.1.32.32,0,0,1,0-.46l1.12-1.12a.32.32,0,0,1,.46,0,.329.329,0,0,1,0,.46L4.28,19.53A.366.366,0,0,1,4.05,19.63Z",
    fill: "#f1f1f2"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9876",
    "data-name": "Group 9876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M19.24,19.77a.3.3,0,0,1-.23-.1l-1.12-1.12a.32.32,0,0,1,0-.46.329.329,0,0,1,.46,0l1.12,1.12a.32.32,0,0,1,0,.46A.3.3,0,0,1,19.24,19.77Z",
    fill: "#f1f1f2"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9877",
    "data-name": "Group 9877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M5.02,5.55a.3.3,0,0,1-.23-.1L3.67,4.34a.332.332,0,0,1,0-.47.32.32,0,0,1,.46,0L5.25,4.99a.32.32,0,0,1,0,.46A.3.3,0,0,1,5.02,5.55Z",
    fill: "#f1f1f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeRemaining);
export default __webpack_public_path__ + "static/media/time_remaining.b044530e626803481680104330ac60b3.svg";
export { ForwardRef as ReactComponent };